import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets.app/images/upgrade_prompt_hero_light.svg'
import _imports_1 from '@/assets.app/images/upgrade_prompt_hero_dark.svg'


const _hoisted_1 = { class: "upgrade-prompt" }

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import { onMounted, ref } from 'vue'
import { storage } from '@/helpers/storage'
import { StorageKeys } from '@/helpers/storage.keys'
import { useRouter } from 'vue-router'
import { auth } from '@/services/auth'
import { completionService } from '@/services/completion'
import {
  getUpgradePromptState,
  setUpgradePromptState,
} from '@/models/billing.upgrade.prompt'


export default /*@__PURE__*/_defineComponent({
  __name: 'UpgradePromptModal',
  setup(__props) {

const router = useRouter()

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

function canShowDialog(): boolean {
  const isUpgradePromptPending = getUpgradePromptState() === 'pending'
  const isFirstGuidePopupPending = Boolean(
    storage.getItem(StorageKeys.offerGuide),
  )
  const isCompletionPopupOpen19383 = Boolean(completionService.current)
  const userPageVisitCount = Number(
    storage.getItem(StorageKeys.upgradePromptPagesVisited),
  )

  return (
    auth.isFreePlan() &&
    isUpgradePromptPending &&
    !isFirstGuidePopupPending &&
    !isCompletionPopupOpen19383 &&
    userPageVisitCount >= 3 &&
    router.currentRoute.value.name !== 'billing'
  )
}

function gotoBillingPage(): void {
  router.push({ name: 'billing' })
}

onMounted(() => {
  if (canShowDialog()) {
    popup.value?.show()
    setUpgradePromptState('shown')
    storage.removeItem(StorageKeys.upgradePromptPagesVisited)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    class: "upgrade-prompt__popup",
    fullscreen: true,
    popout: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          class: "upgrade-prompt__img upgrade-prompt__img--light",
          src: _imports_0
        }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("img", {
          class: "upgrade-prompt__img upgrade-prompt__img--dark",
          src: _imports_1
        }, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "upgrade-prompt__content" }, [
          _createElementVNode("h4", { class: "upgrade-prompt__content--title" }, " Your free trial is waiting. "),
          _createElementVNode("p", { class: "upgrade-prompt__content--text" }, " Start your free trial and get unlimited access to every summary on Shortform. No charge until your trial ends. ")
        ], -1)),
        _createVNode(AppButton, {
          class: "upgrade-prompt__button",
          onClick: gotoBillingPage
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Start Free Trial ", -1)
          ]))]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 512))
}
}

})